<template lang="pug" src="./html/MainNavStageMobileP.pug"></template>

<script>

    import { TweenMax, Expo, Sine, Back, Power1 } from 'gsap'
    import EventBus from './../event-bus'
    import SiteStructure from './tools/site-structure'
    import DragCursor from './tools/drag-cursor'
    import MainNavStageGuide from './MainNavStageGuide'

    const SVG_NS = 'http://www.w3.org/2000/svg'
    const DRAG_SENSITIVITY = 20

    class TopLevelMenu {
      constructor (g) {
        this.g = g
        this.list = []
        this.selectedIndex = -1
        this.highlightIndex = -1
        this.creationX = 0
        this.creationXPad = 30
        this.highlight = g.getElementsByClassName('highlight')[0]
      }
      add (navItem) {
        let t = document.createElementNS(SVG_NS, 'text')
        t.setAttribute('x', this.creationX)
        t.appendChild(document.createTextNode(navItem.label.toUpperCase()))
        t.navItem = navItem
        this.list.push(t)
        this.g.appendChild(t)

        let bb = t.getBBox()
        t._x = bb.x
        t.midX = bb.width >> 1
        this.creationX += bb.width + this.creationXPad
      }
      complete () {
        this.creationWidth = this.creationX - this.creationXPad
      }
      setOffset (offset) {}
      setHighlightIndex (index, skipAnimation) {
        if (index < 0) {
          index = 0
        } else if (index > this.list.length - 1) {
          index = this.list.length - 1
        }
        if (this.highlightIndex === index) return
        this._moveIndex(index, skipAnimation)
        this.highlightIndex = index
      }
      setSelectedIndex (index, skipAnimation, updateOnly) {
        if (this.selectedIndex === index) return
        this._moveIndex(index, skipAnimation)
        this.selectedIndex = this.highlightIndex = index
        if (!updateOnly) {
          SiteStructure.setSelectedItem(this.list[index].navItem)
        }
      }
      _moveIndex (index, skipAnimation) {
        let tx = this.list[index].midX + this.list[index]._x
        let tx2 = ((index - ((this.list.length - 1) * 0.5)) * -30) - (this.creationWidth >> 1)
        if (skipAnimation) {
          TweenMax.to(this.highlight, 0, { x: tx })
          TweenMax.to(this.g, 0, { x: tx2, y: -60 })
        } else {
          TweenMax.to(this.highlight, 0.2, { x: tx, ease: Sine.easeInOut })
          TweenMax.to(this.g, 0.2, { x: tx2, ease: Sine.easeInOut })
        }
      }
    }

    class SecondLevelMenu {
      constructor (vm) {
        this.leftButton = this._createButton(-1, vm.$el.getElementsByClassName('btn-left')[0], vm)
        this.rightButton = this._createButton(1, vm.$el.getElementsByClassName('btn-right')[0], vm)
      }
      hide (fast) {
        this.leftButton.hide(false, fast)
        this.rightButton.hide(false, fast)
      }
      reveal () {
        if (this.activeMenu) {
          if (this.activeMenuIndex === 0) {
            this.leftButton.hide()
            this.rightButton.reveal(this.activeMenu.list[this.activeMenuIndex + 1].label)
          } else if (this.activeMenuIndex >= this.activeMenu.list.length - 1) {
            this.leftButton.reveal(this.activeMenu.list[this.activeMenuIndex - 1].label)
            this.rightButton.hide()
          } else {
            this.leftButton.reveal(this.activeMenu.list[this.activeMenuIndex - 1].label)
            this.rightButton.reveal(this.activeMenu.list[this.activeMenuIndex + 1].label)
          }
        } else {
          this.leftButton.hide()
          this.rightButton.hide()
        }
      }
      reset (activeMenu, activeMenuIndex) {
        if (this.activeMenu === activeMenu && this.activeMenuIndex === activeMenuIndex) return
        this.activeMenu = activeMenu
        this.activeMenuIndex = activeMenuIndex
        this.reveal()
      }
      stepNav (index) {
        if (index < 0) {
          index = 0
        } else if (index >= this.activeMenu.list.length - 1) {
          index = this.activeMenu.list.length - 1
        }
        this.activeMenuIndex = index
        this.reveal()
        SiteStructure.setSelectedItem(this.activeMenu.list[index])
      }
      _createButton (direction, btn, vm) {
        let secondLevelMenu = this
        let arrow = btn.getElementsByClassName('arrow')[0]
        let c = btn.getElementsByClassName('c')[0]

        btn.press = function () {
          if (vm._data.guide || vm._data.carouselGuideMode) return
          TweenMax.to(c, 0.5, { scale: 0.8, transformOrigin: '50% 50%', ease: Expo.easeOut })
          TweenMax.to(arrow, 0.5, { alpha: 1, ease: Expo.easeOut })
        }

        btn.releasePress = function () {
          if (vm._data.guide || vm._data.carouselGuideMode) return
          TweenMax.to(c, 0.6, { scale: 1, ease: Back.easeOut })
          TweenMax.to(arrow, 0.5, { alpha: 0.45, ease: Power1.easeOut })
          secondLevelMenu.stepNav(secondLevelMenu.activeMenuIndex + direction)
        }

        btn.hide = function (skipAnim, fast) {
          btn.text('')
          if (this._hidden) return
          this._hidden = true
          let x = 350 * direction
          let y = 50
          if (skipAnim) {
            TweenMax.to(c, 0, { x: x, y: y })
          } else {
            if (fast) {
              TweenMax.to(c, 0.5, { x: x, y: y, ease: Back.easeOut })
            } else {
              TweenMax.to(c, 1, { x: x, y: y, ease: Power1.easeOut })
            }
          }
        }

        btn.reveal = function (value) {
          btn.text(value)
          if (!this._hidden) return
          this._hidden = false
          TweenMax.to(c, 0.55, { x: 0, y: 0, ease: Expo.easeOut })
        }

        btn.text = function (value) {
        }

        c.addEventListener('touchstart', btn.press)
        c.addEventListener('touchend', btn.releasePress)
        c.addEventListener('touchendoutside', btn.releasePress)

        btn.hide(true)

        return btn
      }
    }

    export default {
      beforeCreate () {
        this._data = {
          guide: false,
          carouselGuideMode: false,
          carouselMode: false
        }
      },
      mounted () {
        // Setup
        let vm = this
        this.setupStage()
        // Guide
        // this.guideWatcher = this.$store.state.guideEngine.mainNavThumb.getWatcher(this.initHowToGuide)
        // if (!this.$store.state.isMobileOrTablet) {
        //   this.$store.state.guideEngine.mainNavThumb.cancel()
        // }
        // Events
        EventBus.$on('onWindowResize', function (w, h) {
          vm.setStagePos()
        })
        EventBus.$on('Nav.CHANGE', function (e) {
          vm.navUpdated(e.navItem)
        })
        window.addEventListener('scroll', function () {
          vm.$el.focus()
        })

        EventBus.$once('GUIDE.ENTER_CAROUSEL_MODE', this.enterCarouselHowToMode)
        EventBus.$once('GUIDE.EXIT_CAROUSEL_MODE', this.exitCarouselHowToMode)

        EventBus.$on('PortfolioMenu.MENU_ENTER', this.enterCarouselMode)
        EventBus.$on('ArticlesMenu.MENU_ENTER', this.enterCarouselMode)
        EventBus.$on('PortfolioMenu.MENU_EXIT', this.exitCarouselMode)
        EventBus.$on('ArticlesMenu.MENU_EXIT', this.exitCarouselMode)
      },
      data () {
        return this._data
      },
      computed: {
        navOpen () {
          return this.$store.state.mainNavOpen
        }
      },
      methods: {
        setupStage () {
          let navMask = this.$el.getElementsByClassName('navMask')[0]
          let navBg = this.$el.getElementsByClassName('navBg')[0]
          navBg.maskUpdate = function () {
            navMask.setAttribute('transform', navBg.getAttribute('transform'))
          }

          let thumbprint = this.$el.getElementsByClassName('thumbprint')[0]
          thumbprint.addEventListener('touchstart', this.openNav)
          thumbprint.addEventListener('touchend', this.closeNav)
          thumbprint.addEventListener('touchendoutside', this.closeNav)
          thumbprint.addEventListener('touchmove', this.dragInNav)

          let navItemsC = this.$el.getElementsByClassName('navItemsC')[0]

          let navList = SiteStructure.getNavTree().list

          let topLevelMenu = new TopLevelMenu(this.$el.getElementsByClassName('navItems')[0])
          for (let i = 0; i < navList.length; i++) {
            topLevelMenu.add(navList[i])
          }
          topLevelMenu.complete()

          let secondLevelMenu = new SecondLevelMenu(this)
          let dragCursor = new DragCursor(topLevelMenu, DRAG_SENSITIVITY)

          this.stageAssets = {
            navBg,
            navItemsC,
            thumbprint,
            topLevelMenu,
            secondLevelMenu,
            dragCursor
          }

          // Init
          this.navUpdated(SiteStructure.getSelectedItem(), true)
          this.setStagePos()
        },
        navUpdated (navItem, updateOnly) {
          if (navItem) {
            if (navItem.depth === 0) {
              this.stageAssets.topLevelMenu.setSelectedIndex(navItem.index, true, updateOnly)
              this.stageAssets.secondLevelMenu.reset(navItem.submenu, 0)
            } else if (navItem.depth === 1) {
              let rootNavItem = navItem.getRootParent()
              this.stageAssets.topLevelMenu.setSelectedIndex(rootNavItem.index, true, true)
              this.stageAssets.secondLevelMenu.reset(rootNavItem.submenu, navItem.index)
            }
          }
        },
        openNav (e) {
          if (this._data.carouselGuideMode) return
          this.$refs.svg.setAttribute('viewBox', '-250 -160 500 240')

          let a = this.stageAssets
          a.secondLevelMenu.hide(true)

          this.endHowToGuide()

          this.$store.state.mainNavOpen = true
          TweenMax.to(a.navItemsC, 0.8, { alpha: 1, y: -10, ease: Expo.easeOut })
          TweenMax.to(a.thumbprint, 0.5, {
            scale: 0.8,
            alpha: 1,
            transformOrigin: '50% 50%',
            ease: Back.easeOut
          })
          TweenMax.to(a.navBg, 0.5, {
            y: 170,
            scaleX: 12,
            scaleY: 7,
            alpha: 0.85,
            transformOrigin: '50% 50%',
            onUpdate: a.navBg.maskUpdate,
            ease: Back.easeOut
          })
          a.dragCursor.onDragStart(e)
          this.$store.state.guideEngine.mainNavThumb.cancel()
        },
        dragInNav (e) {
          this.stageAssets.dragCursor.onDragMove(e)
        },
        closeNav (e) {
          let a = this.stageAssets
          let vm = this
          TweenMax.to(a.navItemsC, 0.8, { alpha: 0, y: 0, ease: Expo.easeOut })
          TweenMax.to(a.thumbprint, 0.5, {
            scale: 1,
            alpha: 0.1,
            ease: Expo.easeOut,
            onComplete: function () {
              vm.$store.state.mainNavOpen = false
              vm.$refs.svg.setAttribute('viewBox', '-250 -60 500 140')
            }
          })
          TweenMax.to(a.navBg, 0.5, {
            alpha: 0.3,
            scale: 1,
            y: 0,
            onUpdate: a.navBg.maskUpdate,
            ease: Expo.easeOut
          })
          a.dragCursor.onDragEnd(e)
          a.secondLevelMenu.reveal()
        },
        setStagePos () {
          let secondLevelMenu = this.stageAssets.secondLevelMenu
          TweenMax.to(secondLevelMenu.leftButton, 0, { x: window.innerWidth * -0.4 })
          TweenMax.to(secondLevelMenu.rightButton, 0, { x: window.innerWidth * 0.4 })
          if (window.innerWidth > window.innerHeight) {
            this.$store.state.guideEngine.mainNavThumb.cancel()
          }
        },
        initHowToGuide () {
          if (this._guide || this._data.carouselMode) return
          this.$store.state.guideEngine.howToRunning()
          this._guide = MainNavStageGuide
          this._data.guide = this._guide._data
          this._guide.init()
        },
        endHowToGuide () {
          if (!this._guide) return
          this._guide.complete()
          this._data.guide = null
          this._guide.$destroy()
          this._guide = null
          this.$store.state.guideEngine.howToComplete()
        },
        enterCarouselHowToMode () {
          this._data.carouselGuideMode = true
        },
        exitCarouselHowToMode () {
          this._data.carouselGuideMode = false
        },
        enterCarouselMode (e) {
          this._data.carouselMode = e.viaDrag
        },
        exitCarouselMode () {
          this._data.carouselMode = false
        }
      }
    }

</script>

<style scoped lang="sass" src="./style/MainNavStageMobileP.sass"></style>
